import { isEmailSignupEnabled } from 'src/utils';

export enum AppRoutes {
  HOME = '/',
  MANAGE_ACCOUNT = '/manage-account',
  SIGN_UP = '/sign-up',
  SIGN_UP_WITH_EMAIL = `/sign-up-with-email`,
  LOGIN = '/login',
  LOGOUT = '/logout',
  LOGIN_WITH_EMAIL = '/login-with-email',
  LOGIN_ERROR = '/login-error',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  VERIFICATION_FAILED = '/verification-failed',
  VERIFIED = '/verified',
  PASSWORD_RESET_FAILED = '/password-reset-failed',
  PAYMENT = '/payment',
  WELCOME = '/welcome',
  INVITE = '/invite',
  AMP_ONBOARD = '/amp-onboard',
  NOT_FOUND = '/not-found',
  CANCEL_SUBSCRIPTION = '/cancel-subscription',
  REFERRAL = '/referral/:referralCode',
  VIDEO_TUTORIALS = '/video-tutorials',
  ADD_ON = '/add-on',
  CHAT_HISTORY = '/chat-history',
  WILDCARD = '*',
}

export const AuthRoutes = [
  AppRoutes.AMP_ONBOARD,
  AppRoutes.FORGOT_PASSWORD,
  AppRoutes.INVITE,
  AppRoutes.LOGIN,
  AppRoutes.LOGOUT,
  AppRoutes.LOGIN_ERROR,
  AppRoutes.LOGIN_WITH_EMAIL,
  AppRoutes.PASSWORD_RESET_FAILED,
  AppRoutes.SIGN_UP,
  ...(isEmailSignupEnabled ? [AppRoutes.SIGN_UP_WITH_EMAIL] : []),
];

export enum UserSettingsNestedRoutes {
  SUBSCRIPTION = 'subscription',
  PROFILE = 'profile',
  INTEGRATIONS = 'integrations',
  GENERAL = 'general',
  ACTIVITY = 'activity',
  MANAGE_USERS = 'users',
}

export enum APINestedRoutes {
  CREDITS = 'credits',
  API_KEYS = 'api-keys',
  API_USAGE = 'credit-usage',
}

export enum DownloadNestedRoutes {
  DOWNLOAD = 'download-app',
}

export const QUERY_SEARCH_PARAM = 'query';

export interface QueryParams {
  session_id?: string;
  query?: string;
  conv?: string;
  editor?: string;
  // temporary until our App is verified - Meta needs a prod url to test login functionality
  meta_verification?: string;
  username?: string;
  code?: string;
  state?: string;
  expired_at?: string;
  email?: string;
  error?: string;
  error_description?: string;
  signup_error?: string;
  subscription_succeeded_plan?: string;
  subscription_succeeded_period?: string;
  subscription_succeeded_number_of_seats?: string;
  subscription_succeeded_value?: string;
  subscription_succeeded_currency?: string;
  payment_intent_client_secret?: string;
  ['password-changed']?: string;
  operation_type?: string;
  status?: string;
  to_tier?: string;
  email_verified?: string;
  amp_customer_id?: string;
  amp_product_code?: string;
  amp_fulfill_success?: string;
  invitation_token?: string;
  payment_tab?: string;
  plan?: string;
  task?: string;
  compare?: string;
  first_comparing_conv?: string;
  second_comparing_conv?: string;
  active_compare_list?: string;
  coupon?: string;
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  from_SN?: string;
  selected_plan?: string;
  timestamp?: string;
  open_seats_section?: string;
}

type Links = {
  route: UserSettingsNestedRoutes | DownloadNestedRoutes | APINestedRoutes;
  icon: JSX.Element;
  title: string;
  defaultRoute: boolean;
  disabled: boolean;
  datae2e?: string;
};

export type Navigation = {
  category: string;
  links: Array<Links>;
};

export interface RouteBase {
  index?: boolean;
  element: React.ReactNode;
  path?: string;
  children?: RouteItem[];
}

export interface RouteChild {
  index?: boolean;
  path?: string;
  element: React.ReactNode;
  children?: RouteItem[];
}

export type RouteItem = RouteBase | RouteChild;
